import { mapIntegrals } from './mapIntegrals';
import { updateIntegralsRelativeValues } from './updateIntegralsRelativeValues';
export function updateIntegrals(datum) {
    datum.integrals.values = mapIntegrals(datum.integrals.values, datum, 'current');
    updateIntegralsRelativeValues(datum, true);
}
